// extracted by mini-css-extract-plugin
export default {"wrapper":"DynamicContent_wrapper__5B3Dw","col1":"DynamicContent_col1__SVktw","col2":"DynamicContent_col2__YD8kJ"};